import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://srwqfohvsbhjpyhkvuae.supabase.co';
const supabaseKey = 'sb_publishable_UHWVGUuZV5UkE2LQ05rHFQ_gdoNXz5Y';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.localStorage,
    storageKey: 'sb-renterrep-auth',
    detectSessionInUrl: true,
  },
});
